module.exports = "/_next/static/images/epn-1f338ba774027d275f75c17243b916e6.png";